// extracted by mini-css-extract-plugin
export default {"header":"Text_header__h-lvx","light":"Text_light__qN6LJ","dark":"Text_dark__In6jh"};